// ============================================================
// Wishlist sulle product card — ponte con l'app iWish
// ============================================================
// L'app inizializza i bottoni `.iWishAdd.iWishAddColl.iwishcheck` solo se
// `iWishData.iwish_add_txt_col` è definito (app block "collezione"). Qui
// forniamo quei testi come sola icona, così l'app gestisce click, stato
// (classe .iwishAdded) e persistenza, e il tema controlla l'aspetto.
// Le card inserite dopo il load (filtri ajax, quickbuy, load more) vengono
// registrate presso l'app tramite MutationObserver.

const HEART_SVG = '<svg class="icon" width="20" height="18" viewBox="0 0 20 18" fill="none" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg"><path d="M10 17C10 17 1 11.5 1 5.5C1 3.01472 3.01472 1 5.5 1C6.96712 1 8.27301 1.67627 9.13208 2.73547C9.44212 3.11517 9.69678 3.54247 9.87939 4H10.1206C10.3032 3.54247 10.5579 3.11517 10.8679 2.73547C11.727 1.67627 13.0329 1 14.5 1C16.9853 1 19 3.01472 19 5.5C19 11.5 10 17 10 17Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';

let appReady = false;
let bound = false;
let refreshTimer = null;

// Registra presso l'app i bottoni non ancora inizializzati (.iwishcheck).
function refresh() {
  clearTimeout(refreshTimer);
  refreshTimer = setTimeout(() => {
    if (appReady && bound && window.iWish && typeof window.iWish.checkIwishColl === 'function') {
      window.iWish.checkIwishColl();
    }
  }, 50);
}

// Callback che l'app invoca a fine init: da qui in avanti i bottoni
// aggiunti dinamicamente vanno registrati a mano.
const prevInitFn = window.iWishinitFn;
window.iWishinitFn = function () {
  if (typeof prevInitFn === 'function') prevInitFn();
  appReady = true;
  refresh();
};

// L'app embed viene iniettato a fine body, dopo questo script: iWishData
// puo' non esistere ancora. Si riprova su DOMContentLoaded (prima dell'init
// dell'app, che parte dallo stesso evento) e in fallback a intervalli.
function bind() {
  if (bound) return true;
  const data = window.iWishData;
  if (!data) return false;
  bound = true;

  document.documentElement.classList.add('mm-iwish-ready');

  // Testi collezione: se il merchant attiva l'app block dedicato, i suoi
  // valori hanno la precedenza (già definiti qui).
  if (typeof data.iwish_add_txt_col === 'undefined') data.iwish_add_txt_col = HEART_SVG;
  if (typeof data.iwish_added_txt_col === 'undefined') data.iwish_added_txt_col = HEART_SVG;

  refresh();
  return true;
}

if (!bind()) {
  document.addEventListener('DOMContentLoaded', bind);
  let tries = 0;
  const poll = setInterval(() => {
    if (bind() || ++tries > 50) clearInterval(poll);
  }, 100);
}

const observer = new MutationObserver(mutations => {
  for (const { addedNodes } of mutations) {
    for (const node of addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches('.iwishcheck') || node.querySelector('.iwishcheck')) {
        refresh();
        return;
      }
    }
  }
});

const start = () => observer.observe(document.body, { childList: true, subtree: true });
if (document.body) start();
else document.addEventListener('DOMContentLoaded', start);
